module.exports = __webpack_public_path__ + "static/media/11NEPAD3.07fc99af.jpg";